import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getGooglePlaces = async (query, limit = 5) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/maps/google/places`, {
      params: {
        q: query,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching Google places:', error.response?.data || error);
    throw error;
  }
};

export const getGoogleGeocode = async (query) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/maps/google/geocode`, {
      params: {
        q: query,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching Google geocode:', error.response?.data || error);
    throw error;
  }
};

export const getGoogleTileUrl = () => `${API_URL}/maps/google/tiles/{z}/{x}/{y}`;
